import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'or',
    standalone: false
})
export class OrPipe implements PipeTransform {
    public transform(a: unknown, b: unknown): unknown {
        return a || b;
    }
}
